@if (caption !== undefined && caption !== null) {
  <mat-label class="text-xl font-bold">{{ caption }}</mat-label>
}
<div class="flex flex-row w-full">
  <div class="flex flex-col w-1/3">
    <mat-label>Añadir nuevos archivos</mat-label>
    <div class="h-60 p-4 overflow-auto rounded-2xl bg-card outline-solid outline-primary outline-0 border"
      [class.outline-4]="isDragOver" [class.cursor-pointer]="!control.disabled" (click)="fileInput.click()" [host]="this" multidropFile>

      @if (maxError) {
        <mat-error>
          {{ 'maxFilesReached' | transloco }}
        </mat-error>
      }
      @if (minError) {
        <mat-error>
          {{ 'minFilesRequired' | transloco:{ number: min } }}
        </mat-error>
      }

      <!-- image container with actions -->
      <div class="z-10 w-fill inset-0 flex flex-col p-4 relative">

        <!-- image container -->
        <div class="flex items-center justify-center relative">

          <!-- default icon if no image is present -->
          <mat-icon class="icon-size-14 text-hint" svgIcon="heroicons_solid:document-add"></mat-icon>

        </div>
      </div>

      <!-- bottom text -->
      <div class="flex flex-col flex-auto justify-center text-center text-sm font-medium">

        <!-- file name -->
        <!-- TODO filename DOES NOT EXIST -->
        <!-- <div *ngIf="filename" class="truncate" [matTooltip]="filename">{{ filename }}</div> -->

        <!-- 'choose a file' text -->
        <div class="truncate" [matTooltip]="'chooseOrDropAFile' | transloco">{{ 'chooseOrDropAFile' | transloco }}</div>

        <!-- accepted extensions -->
        @if (acceptedExtensions.length > 0) {
          <div class="text-secondary truncate">
            {{ 'acceptedExtensions' | transloco:{ extensions: acceptedExtensions.join(', ') } }}
          </div>
        }
      </div>

      <!-- file input -->
      <input class="hidden" #fileInput (change)="onFileSelected($event)" type="file" multiple="true" [disabled]="control.disabled" />

      <!-- progress bar -->
      @if (loading) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
    </div>
  </div>
  <div class="flex flex-col w-2/3">
    @if (printedFiles.length > 0) {
      <mat-label class="ml-6">Archivos subidos</mat-label>
    }
    @if (printedFiles.length > 0) {
      <div class="ml-6 h-60 px-4 overflow-auto rounded-2xl bg-card outline-solid outline-primary outline-0 border">
        <mat-list>
          @for (file of this.printedFiles; track file; let i = $index) {
            <mat-list-item class="flex-flex-row h-auto mb-2">
              <div class="flex flex-row items-center">
                <!-- image from url -->
                @if (file.isImage && file.imageUrl && !file.base64) {
                  <img class="max-h-28 aspect-auto max-w-28 border mr-2" [src]="file.imageUrl">
                }
                <!-- image from base 64 -->
                @if (file.isImage && file.base64) {
                  <img class="max-h-28 aspect-auto max-w-28 border mr-2" [src]="file.base64">
                }
                <!-- default icon if no image is present -->
                @if (!file.isImage || (!file.base64 && !file.imageUrl)) {
                  <mat-icon class="icon-size-14 text-hint"
                  svgIcon="heroicons_solid:document-add"></mat-icon>
                }
                @if (file.filename) {
                  <div class="truncate" [matTooltip]="file.filename">{{ file.filename }}</div>
                }
                <!-- preview image -->
                @if (file.isImage) {
                  <button mat-icon-button class="top-0 m-2 pointer-events-auto" (click)="previewFile($event, i)"
                    matTooltip="{{'previewFile' | transloco}}">
                    <mat-icon class="icon-size-5" svgIcon="heroicons_solid:eye"></mat-icon>
                  </button>
                }
                <!-- download image -->
                <button mat-icon-button class="top-0 m-2 pointer-events-auto" (click)="downloadFile($event, file)"
                  matTooltip="{{'downloadFile' | transloco}}">
                  <mat-icon class="icon-size-5" svgIcon="mat_outline:download"></mat-icon>
                </button>
                <!-- remove image -->
                <button mat-icon-button class="top-0 m-2 pointer-events-auto" (click)="removeFile($event, file)"
                  matTooltip="{{'removeFile' | transloco}}" [disabled]="control.disabled">
                  <mat-icon class="icon-size-5" svgIcon="heroicons_solid:x"></mat-icon>
                </button>
              </div>
            </mat-list-item>
          }
        </mat-list>
      </div>
    }
  </div>
</div>